import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy, Injector, AfterViewInit, Output, EventEmitter } from "@angular/core";
import { ControlValueAccessor, NgControl, Validators, FormControl } from '@angular/forms';
import { WorkflowComponentsService, EventWorkflowValuesChanged } from '../workflow-components.service';
import { takeUntil, filter, distinctUntilChanged, last } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Model_WorkflowComponent, WorkflowComponentObserver, TYPE_WORKFLOW_COMPONENT_OBSERVER, TYPE_DEFAULT_VALUE, Expression, Model_VariableEnvironnementUser } from 'src/app/app.models';
import * as mathjs from 'mathjs'
import { ExpressionBuilderService } from '../expression-builder/expression-builder.service';
import { COMPONENT_UI } from '../workflow-components.models';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { ApplyFilterDatasource } from '../datasource-picker/datasource.helper';

@Component({ template: '' })
export abstract class AbstractWorkflowFormComponent<T = any, U = any> implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
    @Input() value: any;
	@Input() model: T;
	@Output() change = new EventEmitter();
    onComplete = new Subject();
    datasourceDatas: any[] = [];
	gridDatasourceDatas: any;
    datasourceFilteredDatas: any[] = [];
	datasourceComponentRefreshed = true;
	ngControl: NgControl;
	COMPONENT_UI = COMPONENT_UI;
	formatStyle: any = null;

    constructor(
        protected _workflowComponentsService: WorkflowComponentsService,
        protected _cdf: ChangeDetectorRef,
		protected _injector: Injector
	) {
    }

    ngOnInit() {
		if (!!this.model) {
			if ((this.model as any).datas !== undefined) {
				this.datasourceDatas = (this.model as any).datas;
				this.datasourceFilteredDatas = !!(this.model as any).filteredDatas && (this.model as any).filteredDatas.length > 0 ? (this.model as any).filteredDatas : []; 
			}

			this._workflowComponentsService.workflowValuesChanged$.pipe(
				takeUntil(this.onComplete), 
				/*filter(_change => {
					const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
					const formGroupId = workflowComponent.FORM_ID || '_FORM_';
					return !_change.sender || (!!_change.sender && !!_change.sender.FORM_ID && _change.sender.FORM_ID == formGroupId && _change.sender.ID != workflowComponent.ID);
				}),*/
			).subscribe(async _change => {
				_change = this._evaluateObservers(_change);
				await this._evaluateRelations(_change);
				await this._evaluateConditionalFormating(_change);
				try { this._cdf.detectChanges(); } catch(e) {}
			});

			this._workflowComponentsService.gridComponentsValuesChanged$.pipe(
				takeUntil(this.onComplete)
			).subscribe(async _change => {
				if (!_change) { return; }

				const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
				if (!!workflowComponent && !!workflowComponent.UIC_PARAMS && !!workflowComponent.UIC_PARAMS.OBSERVERS) {
					const formGroupId = workflowComponent.FORM_ID || '_FORM_';
					const observers: WorkflowComponentObserver[] = workflowComponent.UIC_PARAMS.OBSERVERS;
					if (!!observers) {
						observers.forEach((_observer: WorkflowComponentObserver) => {
							switch(_observer.type) {
								case TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_GRID_VALUE:
									if (_observer.field == _change.sender?.ID && formGroupId == _change.formId) {
										const targetComponentModel: any = _change.rowModels.find(m => m.id == _observer.field);
										if (!!targetComponentModel && !!targetComponentModel.filteredDatas && !!targetComponentModel.valueField) {
											const selectedData = targetComponentModel.filteredDatas.find(d => d[targetComponentModel.valueField] == _change.gridValue[_change.rowIndex][_observer.field]);
											if (!!selectedData && !!selectedData[_observer.params.DS_PROPERTY] !== null) {
												this.onValueChanged(selectedData[_observer.params.DS_PROPERTY], true);
											}
										}
									}
									break;
							}
						});
					}
				}
			});
		}
    }

	ngAfterViewInit() {
		try {
			this.ngControl = this._injector.get(NgControl);
			this.ngControl.control.updateValueAndValidity();
			
			const change = this._evaluateObservers(this._workflowComponentsService.context);
			this._evaluateRelations(change).then(() => 
				this._evaluateConditionalFormating(change)/*.then(() => this._cdf.detectChanges())*/
			);
		} catch(e) {}

	}

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

	private _evaluateObservers(_change: EventWorkflowValuesChanged) {
		const authService = this._injector.get(AuthService);
		const variablesEnvironment = authService.envVariables$.value;
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const workflowComponents = !!_change.workflow ? Array.prototype.concat.apply([], _change.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS).map(step => step.COMPONENTS)) : [];
		let formGroupId = workflowComponent.FORM_ID || '_FORM_';
		if (!!workflowComponent && !!workflowComponent.UIC_PARAMS && !!workflowComponent.UIC_PARAMS.OBSERVERS) {
			const observers: WorkflowComponentObserver[] = workflowComponent.UIC_PARAMS.OBSERVERS;
			if (!!observers) {
				observers.forEach((_observer: WorkflowComponentObserver) => {
					const observerFormId = _observer.formId || formGroupId;
					//const observerFormId = _observer.formId || '_FORM_';
					switch(_observer.type) {
						case TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE:
							if (!!_change.formValues && !!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field]) {
								this.datasourceDatas = _change.formValues[observerFormId][_observer.field].DS_COLUMNS.map(c => ({ value: c.name, display: c.name}));
								this.datasourceFilteredDatas = this.datasourceDatas;
							}
							break;

						case TYPE_WORKFLOW_COMPONENT_OBSERVER.FILTER_DATASOURCE:
							if (!!_change.sender) {
								if (_change.sender.ID == _observer.field && (!_change.sender.FORM_ID || _change.sender.FORM_ID == formGroupId)) {
									// TODO: LOOP SUR this.model.additional.NUM_DATASOURCE.DS_FILTERS et FILTRER [datasourceDatas]
									let filteredDatas = this.datasourceDatas;
									if (!!workflowComponent.NUM_DATASOURCE && !!workflowComponent.NUM_DATASOURCE.DS_FILTERS) {
										for (var f in workflowComponent.NUM_DATASOURCE.DS_FILTERS) {
											const filterOp = workflowComponent.NUM_DATASOURCE.DS_FILTERS[f];
											let senderValue: any = null;
											if (filterOp.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.CONSTANT) {
												senderValue = filterOp.DEFAULT_VALUE;
											} else if (filterOp.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
												senderValue = !!_change.formValues[observerFormId] && _change.formValues[observerFormId][filterOp.DEFAULT_VALUE] !== undefined ? _change.formValues[observerFormId][filterOp.DEFAULT_VALUE] : null
											} else if (filterOp.TYPE_DEFAULT_VALUE == TYPE_DEFAULT_VALUE.WORKFLOW_GRID_FIELD) {
												senderValue = !!_change.formValues[observerFormId] && _change.formValues[observerFormId][filterOp.DEFAULT_VALUE] !== undefined ? _change.formValues[observerFormId][filterOp.DEFAULT_VALUE] : null
											}
											if (senderValue != null) {
												filteredDatas = filteredDatas.filter(d => ApplyFilterDatasource(filterOp, senderValue, d)); 
											}
										}
									}
									this.datasourceFilteredDatas = filteredDatas; 
									this.onValueChanged(null, false);
									_change.formValues[workflowComponent.FORM_ID][workflowComponent.ID] = null;
								}
							} else if (!!_change.formValues && !!_change.formValues[observerFormId] && !!_change.formValues[observerFormId][_observer.field]?.DS_COLUMNS) {
								this.datasourceDatas = _change.formValues[observerFormId][_observer.field].DS_COLUMNS.map(c => ({ value: c.name, display: c.name}));
								this.datasourceFilteredDatas = this.datasourceDatas;
							}
							break;

						case TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_VALUE:
							if (!_change.sender || _observer.field == _change.sender?.ID) {
								if (!!_change.formValues && !!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field]) {
									if (!!_observer.params && !!_observer.params.DS_PROPERTY && !!_change.formModels && !!_change.formModels[observerFormId]) {
										const targetComponentModel: any = _change.formModels[observerFormId].find(m => m.id == _observer.field);
										if (!!targetComponentModel && !!targetComponentModel.filteredDatas && !!targetComponentModel.valueField) {
											const selectedData = targetComponentModel.filteredDatas.find(d => d[targetComponentModel.valueField] == _change.formValues[observerFormId][_observer.field]);
											if (!!selectedData && !!selectedData[_observer.params.DS_PROPERTY]) {
												this.onValueChanged(selectedData[_observer.params.DS_PROPERTY], false);
												_change.formValues[workflowComponent.FORM_ID][workflowComponent.ID] = selectedData[_observer.params.DS_PROPERTY];
											}
										}
									} else if (!!_change.formValues[observerFormId] && workflowComponent.TYPE_DEFAULT_VALUE !== TYPE_DEFAULT_VALUE.COMPUTED) {
										const callersStack = !!_change.callersStack ? _change.callersStack : [];
										if (callersStack.lastIndexOf(workflowComponent.ID) == -1) {
											callersStack.push(workflowComponent.ID);
										}
										//this.onValueChanged(_change.formValues[observerFormId][_observer.field], true, callersStack);
										this.onValueChanged(_change.formValues[observerFormId][_observer.field], false);
										_change.formValues[workflowComponent.FORM_ID][workflowComponent.ID] = _change.formValues[observerFormId][_observer.field];
									}
								} else if (!!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field] !== undefined) {
									this.onValueChanged(_change.formValues[observerFormId][_observer.field], false);
									_change.formValues[workflowComponent.FORM_ID][workflowComponent.ID] = _change.formValues[observerFormId][_observer.field];
								}
							}
							break;

						case TYPE_WORKFLOW_COMPONENT_OBSERVER.ASSIGN_WORKFLOW_COMPONENT_DATAS:
							if (!!_change.formValues && !!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field] !== undefined && _change.workflow !== undefined) {
								const targetWorkflowComponent = workflowComponents.find(c => c.ID == _change.formValues[observerFormId][_observer.field]);
								if (targetWorkflowComponent !== undefined && targetWorkflowComponent.NUM_DATASOURCE !== undefined) {
									this.datasourceDatas = targetWorkflowComponent.NUM_DATASOURCE.DS_COLUMNS.map(c => ({ ID: c.name, TEXT: c.name}));
									this.datasourceFilteredDatas = this.datasourceDatas;
								}
							}
							break;

						case TYPE_WORKFLOW_COMPONENT_OBSERVER.ASSIGN_GRID_COLUMNS:
							if (!!_change.formValues && !!_change.formValues[observerFormId] && !!_change.formValues[observerFormId]['GRID_COLUMNS'] && !!_change.formValues[observerFormId]['NUM_DATASOURCE']) {
								const gridColumns = _change.formValues[observerFormId]['GRID_COLUMNS'];
								const datasource = _change.formValues[observerFormId]['NUM_DATASOURCE'];
								(this as any).gridColumns = gridColumns;
								(this as any).datasourceColumns = !!datasource.DS_COLUMNS ? datasource.DS_COLUMNS : [];
							}
							break;

						case TYPE_WORKFLOW_COMPONENT_OBSERVER.LIST_GRID_COLUMNS:
							if (!!_change.formValues && !!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field] !== undefined && !!_change.formModels && !!_change.formModels[observerFormId]) {
								let inputGridComponent: any = _change.formModels[observerFormId].find(m => m.id == _observer.field);
								if (!!inputGridComponent) {
									const datas = inputGridComponent.datas.find(d => d[inputGridComponent.valueField] == _change.formValues[observerFormId][_observer.field]);
									if (!!datas) {
										this.datasourceDatas = datas.GRID_COLUMNS;
										this.datasourceFilteredDatas = datas.GRID_COLUMNS;
									}
								}
							}
							break;

						/*case TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVER_GRID_VALUE:
							if (!!_change.sender && _observer.field == _change.sender?.ID) {
								if (!!_change.formValues && !!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field]) {
									if (!!_observer.params && !!_observer.params.DS_PROPERTY && !!_change.formModels && !!_change.formModels[observerFormId]) {
										const targetComponentModel: any = _change.formModels[observerFormId].find(m => m.id == _observer.field);
										if (!!targetComponentModel && !!targetComponentModel.filteredDatas && !!targetComponentModel.valueField) {
											const selectedData = targetComponentModel.filteredDatas.find(d => d[targetComponentModel.valueField] == _change.formValues[observerFormId][_observer.field]);
											if (!!selectedData) {
												if (selectedData[_observer.params.DS_PROPERTY] !== undefined || selectedData[_observer.params.DS_PROPERTY] !== null) {
													this.onValueChanged(selectedData[_observer.params.DS_PROPERTY], true);
													_change.formValues[_change.sender.FORM_ID][workflowComponent.ID] = selectedData[_observer.params.DS_PROPERTY];
												}
											}
										}
									} else if (!!_change.formValues[observerFormId]) {
										this.onValueChanged(_change.formValues[observerFormId][_observer.field], false);
										_change.formValues[_change.sender.FORM_ID][workflowComponent.ID] = _change.formValues[observerFormId][_observer.field];
									}
								} else if (!!_change.formValues[observerFormId] && _change.formValues[observerFormId][_observer.field] !== undefined) {
									this.onValueChanged(_change.formValues[observerFormId][_observer.field], false);
									_change.formValues[_change.sender.FORM_ID][workflowComponent.ID] = _change.formValues[observerFormId][_observer.field];
								}
							}
							break;*/
					}
				});
				if (workflowComponent.TYPE_DEFAULT_VALUE === TYPE_DEFAULT_VALUE.COMPUTED) {
					let matchedObserver = observers.find(o => o.field == _change.sender?.ID);
					if (matchedObserver !== undefined || !_change.sender) {
						for (var o in observers) {
							const relatedObserver = observers[o];
							let regex = /\@\[([\w]+)\]/g;
							let computedControls = relatedObserver.params.match(regex);
							if (!!computedControls) {
								var expression = relatedObserver.params;
								computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
									//var fieldValue = !!this.ngControl && !!this.ngControl.control.parent && !!this.ngControl.control.parent.controls && !!this.ngControl.control.parent.controls[field] ? this.ngControl.control.parent.controls[field].value : 0;
									var fieldValue = _change.formValues[formGroupId][field];
									try {
										fieldValue = parseFloat(fieldValue.replace(/\s/g, "").replace(",", "."));
									} catch(e) {}
									if (isNaN(fieldValue)) {
										fieldValue = 0;
									}
									expression = expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), fieldValue);
								});
							}

							regex = /\#\[([\w]+)\]/g;
							computedControls = expression.match(regex);
							if (!!computedControls) {
								computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((match) => {
									const matchedVariable = variablesEnvironment.find(c => c.NOM_VARIABLE == match);
									if (!!matchedVariable) {
										var fieldValue = parseFloat(matchedVariable.VALEUR_VARIABLE);
										if (isNaN(fieldValue)) {
											fieldValue = 0;
										}
										expression = expression.replace(new RegExp('\\#\\[' + match + '\\]', 'g'), fieldValue.toString());
									}
								});
							}
							
							let result: any = 0;
							try {
								result = mathjs.evaluate(expression);
							} catch(e) {}
							this.onValueChanged(result, false);
							_change.formValues[workflowComponent.FORM_ID][workflowComponent.ID] = result;
						}
					}
				}
			}
		}
		return _change;
	}

	private async _evaluateRelations(_change: EventWorkflowValuesChanged) {
		const expressionBuilderService = this._injector.get(ExpressionBuilderService);
		const authService = this._injector.get(AuthService);
		const variablesEnvironment = authService.envVariables$.value;
		await this._evaluateVisibilityExpression(expressionBuilderService, _change, variablesEnvironment);
		await this._evaluateEnabledExpression(expressionBuilderService, _change, variablesEnvironment);
		await this._evaluateRequiredExpression(expressionBuilderService, _change, variablesEnvironment);
		await this._evaluateValidationExpression(expressionBuilderService, _change, variablesEnvironment);
	}

	private async _evaluateVisibilityExpression(_expressionBuilderService: ExpressionBuilderService, _change: EventWorkflowValuesChanged, _variablesEnvironment: Model_VariableEnvironnementUser[]) {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
		const expression: Expression = workflowComponent.CONDITIONS_VISIBILITY;
		const visibleIfProperty = workflowComponent.IS_VISIBLE !== undefined ? workflowComponent.IS_VISIBLE : true;
		const requiredIfProperty = workflowComponent.IS_REQUIRED !== undefined ? workflowComponent.IS_REQUIRED : false;
		if (!!expression?.rules && expression.rules.length > 0) { 
			if (_change.sender !== undefined/* && _expressionBuilderService.doCheckIfExpressionContainsField(expression, _change.sender.ID)*/) {
				const buildedExpression = await _expressionBuilderService.doBuildExpression(expression, {
					eventWorkflowValuesChanged: _change,
					environmentVariables: _variablesEnvironment, 
					formGroupId: formGroupId,
					initialState: true,
				});
				(this.model as any).hidden = !buildedExpression;
				if (!!this.ngControl) {
					if ((this.model as any).hidden) {
						this.ngControl.control.setValidators(null);
						this.ngControl.control.setErrors(null, { emitEvent: false });
					} else {
						if (requiredIfProperty) { 
							try {
								this.ngControl.control.setValidators(this.ngControl.control.validator ? [this.ngControl.validator, Validators.required] : Validators.required); 
							} catch(e) {}
						}
						this.ngControl.control.updateValueAndValidity({ emitEvent: false });
					}
				}
			} else {
				(this.model as any).hidden = !visibleIfProperty;
			}
		}
	}

	private async _evaluateEnabledExpression(_expressionBuilderService: ExpressionBuilderService, _change: EventWorkflowValuesChanged, _variablesEnvironment: Model_VariableEnvironnementUser[]) {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
		const expression: Expression = workflowComponent.CONDITIONS_ENABLED;
		if (!!expression && _change.sender !== undefined && _expressionBuilderService.doCheckIfExpressionContainsField(expression, _change.sender.ID)) {
			const buildedExpression = await _expressionBuilderService.doBuildExpression(expression, {
				eventWorkflowValuesChanged: _change,
				environmentVariables: _variablesEnvironment, 
				formGroupId: formGroupId,
				initialState: true
			});
			(this.model as any).readOnly = !buildedExpression;
		}
	}

	private async _evaluateRequiredExpression(_expressionBuilderService: ExpressionBuilderService, _change: EventWorkflowValuesChanged, _variablesEnvironment: Model_VariableEnvironnementUser[]) {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
		const expression: Expression = workflowComponent.CONDITIONS_REQUIRED;
		if (!!expression && _change.sender !== undefined && _expressionBuilderService.doCheckIfExpressionContainsField(expression, _change.sender.ID)) {
			const buildedExpression = await _expressionBuilderService.doBuildExpression(expression, {
				eventWorkflowValuesChanged: _change.formValues,
				environmentVariables: _variablesEnvironment, 
				formGroupId: formGroupId,
				initialState: true
			});
			(this.model as any).required = buildedExpression;
		}
	}

	private async _evaluateValidationExpression(_expressionBuilderService: ExpressionBuilderService, _change: EventWorkflowValuesChanged, _variablesEnvironment: Model_VariableEnvironnementUser[]) {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
		const expression: Expression = workflowComponent.CONDITIONS_VALIDITION;
		
		if (!!expression && !!this.ngControl?.control) {
			//if (_change.sender !== undefined && _expressionBuilderService.doCheckIfExpressionContainsField(expression, _change.sender.ID)) {
				const buildedExpression = await _expressionBuilderService.doBuildExpression(expression, {
					eventWorkflowValuesChanged: _change,
					environmentVariables: _variablesEnvironment, 
					formGroupId: formGroupId,
					initialState: true
				});
				if (!buildedExpression && !(this.model as any).hidden) {
					if (!this.ngControl.control.errors || !this.ngControl.control.errors['QUERY_BUILDER_VALIDATION']) {
						const errMessage = await _expressionBuilderService.doGetErrorExpression(expression);
						this.ngControl.control.setErrors({'QUERY_BUILDER_VALIDATION': errMessage}, { emitEvent: false });
					}
				} else {
					this.ngControl.control.setErrors(null, { emitEvent: false });
				}
			//}
		}
	}

	private async _evaluateConditionalFormating(_change: EventWorkflowValuesChanged) {
		const expressionBuilderService = this._injector.get(ExpressionBuilderService);
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
		const expressions: any[] = workflowComponent.CONDITIONS_FORMATTING;
		if (!!expressions) {
			const authService = this._injector.get(AuthService);
			const variablesEnvironment = authService.envVariables$.value;

			for(var i = 0; i < expressions.length; i++) {
				const expression = expressions[i];
				if (!!expression.FORMAT_CONDITIONS) {
					const buildedExpression = await expressionBuilderService.doBuildExpression(expression.FORMAT_CONDITIONS, {
						eventWorkflowValuesChanged: _change,
						environmentVariables: variablesEnvironment, 
						formGroupId: formGroupId,
						initialState: true,
					});
					if (buildedExpression == true && !!expression.FORMAT_STYLES) {
						this.formatStyle = expression.FORMAT_STYLES;
					} else {
						this.formatStyle = null;
					}
					this._cdf.detectChanges();
				}
			}
		}
	}

	hasError() {
		return !!this.ngControl && !!this.ngControl.errors ? Object.keys(this.ngControl.errors).length > 0 : false;
	}

	ngOnDestroy() {
		this.onComplete.next();
		this.onComplete.complete();
	}

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: U) {
        this.value = value; 
    }

	onIonInputValueChanged(_event: any, _emitValue?: boolean) {
        this.value = _event.detail.value;
	  	this.propagateChange(this.value);
        this._cdf.detectChanges();
		this.change.emit(this.value);
        if (_emitValue === undefined || _emitValue === true) {
            this.emitValue();
        }
	}

	onMatInputValueChanged(_event: any, _emitValue?: boolean) {
        this.value = _event.value;
	  	this.propagateChange(this.value);
		try { this._cdf.detectChanges(); } catch(ex) {}
		this.change.emit(this.value);
        if (_emitValue === undefined || _emitValue === true) {
            this.emitValue();
        }
	}

	onValueChanged(_value: U, _emitValue?: boolean, _callersStack?: string[]) {
        this.value = _value;
	  	this.propagateChange(this.value);
		try { this._cdf.detectChanges(); } catch(ex) {}
		this.change.emit(this.value);
        if (!!this.model && (_emitValue === undefined || _emitValue === true)) {
            this.emitValue(_callersStack);
        }
	}

    emitValue(_callersStack?: string[]) {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
		const formGroupId = workflowComponent.FORM_ID || '_FORM_';
        let context: any = this._workflowComponentsService.context;
        if (context.formValues === undefined) { context.formValues = {}; }
        if (context.formModels === undefined) { context.formModels = {}; }
		if (_callersStack !== undefined) { context.callersStack = _callersStack; } else { context.callersStack = []; }
        if (context.formValues[formGroupId] === undefined) { context.formValues[formGroupId] = {}; }
        if (context.formModels[formGroupId] === undefined) { context.formModels[formGroupId] = []; }
		context.sender = {
			ID: workflowComponent.ID,
			value: this.value,
			FORM_ID: formGroupId,
			PARENT_GRID_INPUT_ID: workflowComponent.PARENT_GRID_INPUT_ID 
		};
		try {
			const formControl: NgControl = this._injector.get(NgControl);
			if (!!formControl.control && !!formControl.control.parent) {
				context.formValues[formGroupId] = Object.assign(context.formValues[formGroupId], formControl.control.parent.value);
			}
			this._workflowComponentsService.workflowValuesChanged$.next(context);
		} catch(e) {
			//console.error(e);
		}
    }
} 